import { render, staticRenderFns } from "./ActiveSuppliersTable.vue?vue&type=template&id=49fbcdcb"
import script from "./ActiveSuppliersTable.vue?vue&type=script&lang=js"
export * from "./ActiveSuppliersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports